cb.define([], function () {
  var AP_ap_aurumpricelist_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      var self = this;
	  let gridModel = viewmodel.getGridModel();
		gridModel.on('afterSetDataSource', () => {
			const rows = gridModel.getRows();
			const actions = gridModel.getCache('actions');
			const actionsStates = [];
			rows.forEach(data => {
				const actionState = { };
				actions.forEach(action => {
					actionState[action.cItemName] = { visible: true };
					if (data.status == 1) {
						actionState["btnEdit"] = { visible: false };
						actionState["btnDelete"] = { visible: false };
					}
				  });
				actionsStates.push(actionState);
			});
			gridModel.setActionsState(actionsStates);
		});
		viewmodel.on('afterSetDataSource', () => {
			var data = viewmodel;
		});
    },
 
  }
  try {
    module.exports = AP_ap_aurumpricelist_VM_Extend;
  } catch (error) {

  }
  return AP_ap_aurumpricelist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AP/AP_ap_aurumpricelist_VM.Extend.js